module.exports = __webpack_public_path__ + "fbf483e0678f2f45963db932b2fc5a5b.svg";